import {
  Col,
  Divider,
  Row,
  Typography,
} from "../../../components/common/utils/antd-imports/AntdImports";
import React from "react";

import "./ViewCart.css";
import CampaignsCart from "../../../components/common/cart-campaigns/CartCampaigns";
import BreadcrumbNav from "../../../components/common/bread-crumbs/BreadCrumb";
import { useMediaQuery } from "react-responsive";
import "../../../styles/cartCampaigns.css";
import { useSelector } from "react-redux";

const ViewCart = () => {
  const { Text } = Typography;
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const { campaignCartDetails } = useSelector((state) => state?.campaignscart);
  return (
    <div className="view-cart">
      <div>
        <Row>
          {" "}
          <Col offset={1}>
            {" "}
            {isMobile ? (
              <></>
            ) : (
              <>
                <BreadcrumbNav />
              </>
            )}
            <div className="build-campaign-div">
              <Text className="build-campaign ">Build Campaign</Text>
              <Text className="build-campaign-sub-text">
                {campaignCartDetails
                  ?.filter(Boolean)
                  ?.reduce(
                    (total, campaign) =>
                      total + (campaign?.product_bookings?.length || 0),
                    0,
                  )}{" "}
                assets across{" "}
                {campaignCartDetails?.filter(Boolean)?.length || 0} campaigns
              </Text>
            </div>
          </Col>
        </Row>
      </div>
      <Divider style={{ height: 2 }} />
      <div>
        <CampaignsCart />
      </div>
    </div>
  );
};

export default ViewCart;
